import React from 'react'

const FAQ_ITEMS = [
  {
    q: 'Por que AcheiVagas é gratuito sem anúncios?',
    a: 'Nosso modelo é sustentável por planos pagos opcionais. O plano free existe para provar valor antes de você pagar — sem anúncios invasivos que desviam sua atenção.',
  },
  {
    q: 'Como a IA consegue entender o que eu quero?',
    a: 'Nosso motor faz uma análise contextual da sua busca: quando algo está ambíguo, faz no máximo uma pergunta cirúrgica antes de ranquear resultados. Se a intenção está clara, vai direto. É a diferença entre digitar uma frase natural ("dev java pleno remoto startup") e marcar 15 filtros num formulário.',
  },
  {
    q: 'Vocês hospedam as vagas?',
    a: 'Não. A AcheiVagas é um meta-buscador: indexamos vagas publicadas em portais e sites de empresas. Cada resultado mostra a fonte original e direciona você diretamente para candidatura no site da empresa. Nunca intermediamos sua candidatura.',
  },
  {
    q: 'Meus dados estão seguros? (LGPD)',
    a: 'Sim. Seguimos a Lei Geral de Proteção de Dados (LGPD) rigorosamente. Coletamos apenas o necessário para o funcionamento do serviço, não vendemos dados para terceiros, e você pode solicitar exclusão da sua conta a qualquer momento pelo e-mail privacidade@acheivagas.com.br.',
  },
  {
    q: 'Posso cancelar a assinatura quando quiser?',
    a: 'Sim, sempre. O plano Pro pode ser cancelado a qualquer momento pelo painel de conta — sem multa, sem burocracia. Após o cancelamento, você mantém o acesso Pro até o fim do período já pago.',
  },
  {
    q: 'O que é o botão 🎯 "Calibrar 20s" e o Quiz do Detetive?',
    a: 'É um formulário rápido de 3 telas onde você diz seu cargo, nível, onde aceita trabalhar e qual sua prioridade (salário/estabilidade/flexibilidade). Guardamos no seu navegador (localStorage) — anônimos não precisam de conta. Depois disso, todas as buscas ganham personalização: as vagas ganham um score de match e as melhores aparecem no topo.',
  },
  {
    q: 'O que é o Card ⭐ "Escolha do Detetive"?',
    a: 'Quando uma vaga tem match >= 80% com seu perfil E é publicada direto pela empresa (site próprio ou plataforma de recrutamento oficial como Gupy/Greenhouse), ela ganha destaque especial no topo. Nunca aplicamos esse selo em vagas de agregadores comerciais — só vagas diretas competem por esse destaque.',
  },
  {
    q: 'O que é o painel roxo 🔬 "Raio-X da vaga"?',
    a: 'Um resumo automático da vaga em 3 pontos: Habilidades-chave (o que você precisa saber), Ponto decisivo (o requisito que pode eliminar candidatos) e Diferencial (o que se destaca). Gerado por IA — sempre marcado como sugestão automática. Aparece só nos 3 primeiros resultados pra otimizar custo.',
  },
  {
    q: 'Sou empresa/recrutador. Como verificar minha empresa e ganhar o selo 🟢?',
    a: 'Acesse /dashboard/recruiter/verificacao logado com sua conta B2B. Processo 100% automatizado (sem revisor humano): validamos seu CNPJ na Receita, você prova posse do domínio via DNS TXT ou e-mail corporativo (magic link) e o selo é concedido em minutos. Se o CNPJ mudar de status, o selo é revogado automaticamente.',
  },
  {
    q: 'Quero remover minhas vagas do AcheiVagas (opt-out)',
    a: 'Acesse /legal/opt-out. Você informa o domínio ou URL, publica um registro DNS TXT temporário pra provar posse, e nossa blacklist é atualizada automaticamente. Zero triagem humana, zero e-mails perdidos, zero espera.',
  },
]

export function LandingFAQ() {
  return (
    <section
      className="py-16 md:py-24 relative overflow-hidden bg-gradient-to-b from-slate-50 to-white dark:from-slate-900/40 dark:to-zinc-950"
      aria-labelledby="faq-heading"
    >
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-violet-50 border border-violet-100 dark:bg-violet-950/30 dark:border-violet-900/50 px-3 py-1 text-[10px] md:text-xs font-semibold uppercase tracking-widest text-violet-600 dark:text-violet-300 mb-3 md:mb-4">
            Dúvidas frequentes
          </span>
          <h2
            id="faq-heading"
            className="text-2xl md:text-3xl lg:text-4xl font-bold mb-3 tracking-tight text-slate-900 dark:text-white"
          >
            Perguntas frequentes
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {FAQ_ITEMS.map((item) => (
            <details
              key={item.q}
              className="group rounded-xl border border-gray-200 dark:border-white/10 bg-white dark:bg-slate-900 overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-200"
            >
              <summary className="flex items-center justify-between gap-4 px-5 py-4 cursor-pointer list-none select-none font-semibold text-sm md:text-base text-slate-800 dark:text-gray-100 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                <span>{item.q}</span>
                {/* Chevron via CSS rotate trick */}
                <span
                  className="flex-shrink-0 w-5 h-5 rounded-full border border-gray-200 dark:border-white/10 flex items-center justify-center text-gray-400 dark:text-gray-500 group-open:rotate-180 transition-transform duration-200 text-xs"
                  aria-hidden="true"
                >
                  ▾
                </span>
              </summary>
              <div className="px-5 pb-5 pt-1 text-sm md:text-base text-slate-600 dark:text-slate-400 leading-relaxed border-t border-gray-50 dark:border-white/5">
                {item.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  )
}
